<template>
  <div>
    <div>
      <Breadcrumb>
        <Breadcrumb-item href="#">题库</Breadcrumb-item>
        <Breadcrumb-item>题目模板管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="btn-wrap">
      <Button type="primary" @click="showAddTemplateList=true">添加模板</Button>
    </div>
    <List style="margin-top: 10px" :tableColumns="tableColumns" listUrl=""
        :params="queryParams" :reload="reload">
    </List>

    <CreateTemplateModal v-model="showAddTemplateList" :successCallback="search"></CreateTemplateModal>
    
    <Modal v-model="showUpdateTemplateList" title="编辑题目模板">
      <Form class="form" :rules="Rules" ref="updateTemplateForm" :model="updateTemplateParams">
        <Row>
          <FormItem :label-width="90" label="模板名称" prop='name'>
            <Input v-model="updateTemplateParams.name" placeholder="请输入活动名称用于列表展示"></Input>
          </FormItem>
          <FormItem :label-width="90" label="题目大类" prop='type'>
            <Select v-model="updateTemplateParams.type" clearable>
              <Option value="video" key="1">录音题</Option>
              <Option value="read" key="2">阅读理解</Option>
              <Option value="listen" key="3">听力题</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="90" label="模板英文">
            <Input v-model="updateTemplateParams.english" type="textarea" :rows="4" placeholder="请输入模板英文"></Input>
          </FormItem>
        </Row>
      </Form>
      <div slot="footer">
          <Button type="text" size="large" @click="showUpdateTemplateList = false">取消</Button>
          <Button type="primary" size="large" @click="update">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import CreateTemplateModal from '@/components/question/modal/CreateTemplateModal'
export default {
  components: {
    CreateTemplateModal
  },
  data(){
    return{
      reload: 0,
      showAddTemplateList: false,
      showUpdateTemplateList: false,
      queryParams: {},
      updateTemplateParams: {},
      Rules: {
        name: [
          { type: 'string', required: true, message: '请输入模板名称', trigger: 'blur' },
          { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/, message: '只能输入中文、英文和数字', trigger: 'blur'}
        ],
        type: [
          { required: true, message: '请选择模板大类', trigger: 'blur' }
        ],
      },
      tableColumns: [
        {
          title: 'ID',
          key: 'id',
          align: 'center',
        },
        {
          title: '题目模板',
          key: '',
          align: 'center',
        },
        {
          title: '题目大类',
          key: '',
          align: 'center',
        },
        {
          title: '题目模板对应英文',
          key: '',
          align: 'center',
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params)=>{
            let row = params.row
            return h('a', { on:{ click:()=>this.updateTemplate(row) }}, '编辑')
          }
        }
      ]
    }
  },
  methods: {
    updateTemplate(row) {
      let self = this
      self.updateTemplateParams.name = row.name
      self.updateTemplateParams.type = row.type
      self.updateTemplateParams.english = row.english
      self.showUpdateTemplateList = true
      console.log(`row`, row)
    },
    // 编辑题目模板
    update() {
      let self = this
      self.$refs.updateTemplateForm.validate((valid) => {
        if(!valid) {
          self.$message.waring('信息输入错误！')
          return
        }
        self.$http.post('', self.updateTemplateParams).then(res => {
          if(res){

          }
        }).catch(err => {
          self.$message.error(err)
        })
      })
    },
    search () {
      this.reload = new Date().getTime()
    }
  }
}
</script>

<style scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
  }
</style>


// WEBPACK FOOTER //
// TemplateList.vue?0d14d908